module.exports = __webpack_public_path__ + "static/media/icon-dogecoin.502b4142.svg";